import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './pages/login/login.component';
import {InComponent} from './pages/in/in.component';
import {ExampleComponent} from './pages/example/example.component';
import {ScreeningComponent} from './pages/screening/screening.component';
import {InspectionComponent} from './pages/inspection/inspection.component';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {AuthGuard} from './core/guards/auth.guard';
import {SidebarResolver} from './core/resolvers/sidebar/sidebar.resolver';
import {StockComponent} from './pages/stock/stock.component';
import {WarehouseMapComponent} from './pages/warehouse-map/warehouse-map.component';
import {TasksComponent} from './pages/tasks/tasks.component';
import {DebugComponent} from './pages/debug/debug.component';
import {DebugTasksComponent} from './pages/debug-tasks/debug-tasks.component';
import {PickingComponent} from './pages/picking/picking.component';
import {DispatchComponent} from './pages/dispatch/dispatch.component';
import {MapComponent} from './pages/map/map.component';
import {UsersComponent} from './pages/users/users.component';
import {SetupComponent} from './pages/setup/setup.component';
import {SetupTenantComponent} from './pages/setup/setup-tenant/setup-tenant.component';
import {SetupGroundComponent} from './pages/setup/setup-ground/setup-ground.component';
import {SetupTagsComponent} from './pages/setup/setup-tags/setup-tags.component';
import {SetupLevelsComponent} from './pages/setup/setup-levels/setup-levels.component';
import {SetupFinishComponent} from './pages/setup/setup-finish/setup-finish.component';
import {LedgerComponent} from './pages/ledger/ledger.component';
import {TenantConfigResolverResolver} from './core/resolvers/tenant-config-resolver.resolver';
import {PendingTasksComponent} from './pages/pending-tasks/pending-tasks.component';
import {ForkliftsComponent} from './pages/forklifts/forklifts.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { ProductPickingComponent } from './pages/product-picking/product-picking.component';
import { SetupAdminsComponent } from './pages/setup/setup-admins/setup-admins.component';
import { ProductManagementComponent } from './pages/product-management/product-management.component';
import { UserTypeGuard } from './core/guards/user-type.guard';
import { UserRoles } from '../models/User';
import { UnknownAddressComponent } from './pages/unknown-address/unknown-address.component';
import { ExitComponent } from './pages/exit/exit.component';
import { TenantProcessGuard } from './core/guards/tenant-process.guard';
import { UserRoleResolver } from './core/resolvers/user-role.resolver';
import { ExternalPageGuard } from './core/guards/external-page.guard';
import { SetupPigeonholeComponent } from './pages/setup/setup-pigeonhole/setup-pigeonhole.component';
import { PigeonholeEnabledGuard } from './core/guards/pigeonhole-enabled.guard';
import { PigeonholePageComponent } from './pages/pigeonhole-page/pigeonhole-page.component';
import { SellOrdersComponent } from './pages/sell-orders/sell-orders.component';


const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [ExternalPageGuard]
  },
  {
    path: 'in',
    component: InComponent,
    canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver, role: UserRoleResolver },
    data: { section: 'in', process: 'in', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN] }
  },
  // {
  //   path: 'screening',
  //   component: ScreeningComponent,
  //   resolve: { sidebar: SidebarResolver },
  //   canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard],
  //   data: { section: 'in', process: 'in', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN] }
  // },
  {
    path: 'stock',
    component: StockComponent,
    resolve: { sidebar: SidebarResolver, tenantConfig: TenantConfigResolverResolver, role: UserRoleResolver },
    data: { section: 'stock', process: 'stock', allowedTypes: [UserRoles.MASTER, UserRoles.MANAGER, UserRoles.ADMIN] },
    canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard]
  },
  {
    path: 'pending-tasks',
    component: PendingTasksComponent,
    resolve: { sidebar: SidebarResolver, tenantConfig: TenantConfigResolverResolver, role: UserRoleResolver },
    data: { section: 'stock', process: 'stock', allowedTypes: [UserRoles.MASTER, UserRoles.MANAGER, UserRoles.ADMIN] },
    canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard]
  },
  {
    path: 'inspection',
    component: InspectionComponent,
    resolve: { sidebar: SidebarResolver, role: UserRoleResolver },
    canActivate: [AuthGuard, UserTypeGuard, TenantProcessGuard],
    data: { section: 'inspection', process: 'stock', allowedTypes: [UserRoles.MASTER, UserRoles.MANAGER, UserRoles.ADMIN] }
  },
  {
    path: 'picking',
    component: PickingComponent,
    resolve: { sidebar: SidebarResolver, role: UserRoleResolver },
    canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard],
    data: { process: 'packing', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER] }
  },
  {
    path: 'sell-orders',
    component: SellOrdersComponent,
    resolve: { sidebar: SidebarResolver, role: UserRoleResolver },
    canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard],
    data: { process: 'packing', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER] }
  },
  {
    path: 'dispatch',
    component: DispatchComponent,
    resolve: { sidebar: SidebarResolver, role: UserRoleResolver },
    canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard],
    data: { process: 'out', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN] }
  },
  // {
  //   path: 'example',
  //   component: ExampleComponent 
  // },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'dashboard', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER] }
  },
  {
    path: 'warehouse-map',
    component: WarehouseMapComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'warehouse', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN] }
  },
  {
    path: 'tasks',
    component: TasksComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'tasks', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN] }
  },
  {
    path: 'map',
    component: MapComponent,
    canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver, role: UserRoleResolver },
    data: { section: 'map', process: 'stock', allowedTypes: [UserRoles.MASTER, UserRoles.MANAGER, UserRoles.ADMIN] }
  },
  {
    path: 'map/pigeonhole/:id',
    component: PigeonholePageComponent,
    canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard, PigeonholeEnabledGuard],
    resolve: { sidebar: SidebarResolver, role: UserRoleResolver },
    data: { section: 'map', process: 'stock', allowedTypes: [UserRoles.MASTER, UserRoles.MANAGER, UserRoles.ADMIN] }
  },
  {
    path: 'setup',
    component: SetupComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'setup', allowedTypes: [UserRoles.MASTER] }
  },
  {
    path: 'setup-tenant',
    component: SetupTenantComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'setup', allowedTypes: [UserRoles.MASTER] }
  },
  {
    path: 'setup-admins',
    component: SetupAdminsComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'setup', allowedTypes: [UserRoles.MASTER] }
  },
  {
    path: 'setup-ground',
    component: SetupGroundComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver, role: UserRoleResolver },
    data: { section: 'setup', allowedTypes: [UserRoles.MASTER] }
  },
  {
    path: 'setup-tags',
    component: SetupTagsComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'setup', allowedTypes: [UserRoles.MASTER] }
  },
  {
    path: 'setup-levels',
    component: SetupLevelsComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'setup', allowedTypes: [UserRoles.MASTER] }
  },
  {
    path: 'setup-finish',
    component: SetupFinishComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'setup', allowedTypes: [UserRoles.MASTER] }
  },
  {
    path: 'setup-pigeonhole',
    component: SetupPigeonholeComponent,
    canActivate: [AuthGuard, UserTypeGuard, PigeonholeEnabledGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'setup', allowedTypes: [UserRoles.MASTER] }
  },
  {
    path: 'register',
    component: UsersComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'register', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN] }
  },
  // {
  //   path: 'forklifts',
  //   component: ForkliftsComponent,
  //   canActivate: [AuthGuard],
  //   resolve: { sidebar: SidebarResolver }
  // },
  // {
  //   path: 'ledger',
  //   component: LedgerComponent,
  //   canActivate: [AuthGuard],
  //   resolve: { sidebar: SidebarResolver }
  // },
  // {
  //   path: 'debug',
  //   component: DebugComponent,
  //   canActivate: [AuthGuard],
  //   resolve: { sidebar: SidebarResolver }
  // },
  // {
  //   path: 'debug-tasks',
  //   component: DebugTasksComponent,
  //   canActivate: [AuthGuard],
  //   resolve: { sidebar: SidebarResolver }
  // },
  
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver, role: UserRoleResolver },
    data: { section: 'reports', process: 'stock', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN, UserRoles.MANAGER] }
  },
  {
    path: 'product-picking',
    component: ProductPickingComponent,
    canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'product-picking', process: 'packing', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN] }
  },
  {
    path: 'product-management',
    component: ProductManagementComponent,
    canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'product-management', process: 'stock', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN] }
  },
  {
    path: 'unknown-address',
    component: UnknownAddressComponent,
    canActivate: [AuthGuard, UserTypeGuard, TenantProcessGuard],
    resolve: { sidebar: SidebarResolver },
    data: { section: 'unknown-address', process: 'stock', allowedTypes: [UserRoles.MASTER, UserRoles.ADMIN] }
  },
  {
    path: 'exit',
    component: ExitComponent,
    canActivate: [AuthGuard, TenantProcessGuard, UserTypeGuard],
    resolve: { sidebar: SidebarResolver, role: UserRoleResolver },
    data: { section: 'exit', process: 'stock', allowedTypes: [UserRoles.MASTER, UserRoles.MANAGER, UserRoles.ADMIN] }
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/dashboard', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
